// DialogTeamCancel Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import Button from '../../../common/common/button/button.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'

class DialogTeamCancel extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false
    }

    this._references = {
      confirmAccDelete: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onClose: PropTypes.func,
      onConfirm: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onClose: PropTypes.func,
      onConfirm: null
    }
  }

  show () {
    FabButtonManager.setVisible(false)
    this.setState({ active: true })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({ active: false })
  }

  render () {
    return (
      <Dialog
        active={this.state.active}
        onClose={this.hide.bind(this)}
        modal={false}
      >
        <div className='dialog-teamcancel'>
          <div className='iconbar'>
            <IconButton
              icon='dialog-warning'
              className='modal popupalert'
              canHover={false}
            />
          </div>
          <div className='teamcont'>
            <div className='section'>
              <div className='title'>
                <IntlMessage ident='setting.team.teamCancelTitle' />
              </div>
              <div className='info'>
                <IntlMessage ident='setting.team.teamCancelInfo' />
              </div>
            </div>
            <IconButton
              icon='popup-close'
              className='modal'
              canHover
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='teamact'>
            <Button
              title='setting.team.teamCancelAction'
              icon='common-success-tick'
              className='upgrade'
              canHover={false}
              onClick={this._onConfirm.bind(this)}
            />

            <Button
              title='setting.team.teamCancelSubInfo'
              className='act'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />

            <ConfirmDelete
              ref={this._references.confirmAccDelete}
              title='setting.team.teamCancelDeleteInfo'
              onClickOk={this._onClickDeleteConfirm.bind(this)}
            />
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event handlers */
  _onClickClose (ev) {
    ev.preventDefault()

    if (this.props.onClose) {
      this.props.onClose(ev)
    }
  }

  _onConfirm () {
    if (this._references.confirmAccDelete.current) {
      this._references.confirmAccDelete.current.show()
    }
  }

  _onClickDeleteConfirm () {
    if (this.props.onConfirm) {
      this.props.onConfirm()
    }
  }
}

export default DialogTeamCancel
